module.exports = __webpack_public_path__ + "img/upcoming.c598234b.svg";